import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StudentHeader from './components/StudentHeader';
import Dashboard from './components/Dashboard';
import Courses from './components/Courses';
import Assignments from './components/Assignments';
import Progress from './components/Progress';
import Schedule from './components/Schedule';

export default function StudentPage() {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [userProfile, setUserProfile] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Get user profile from localStorage
    const profile = JSON.parse(localStorage.getItem('userProfile') || '{}');
    setUserProfile(profile);
  }, []);

  const handleProfileUpdate = (updatedProfile: any) => {
    setUserProfile(updatedProfile);
  };

  if (!userProfile) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Đang tải...</p>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard userProfile={userProfile} />;
      case 'courses':
        return <Courses userProfile={userProfile} />;
      case 'assignments':
        return <Assignments userProfile={userProfile} />;
      case 'progress':
        return <Progress userProfile={userProfile} />;
      case 'schedule':
        return <Schedule userProfile={userProfile} />;
      default:
        return <Dashboard userProfile={userProfile} />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <StudentHeader 
        userProfile={userProfile} 
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        onProfileUpdate={handleProfileUpdate}
      />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {renderContent()}
      </main>
    </div>
  );
}
